import PropTypes from 'prop-types';
import { Link } from 'react-router';

import css from 'styles/components/account/returns/returnLegalVerbiage.scss';

const ReturnLegalVerbiage = (_, { marketplace: { legalEntityName } }) => (
  <div className={css.container}>
    If you believe you have received defective or incorrect merchandise, please <Link className={css.contactUs} to="/c/contact-us">Contact Us</Link> prior to mailing in your return.
    Unless otherwise noted, all products are sold by {legalEntityName}.
    We will be refunding the Credit Due to the original form of payment.  Please allow 1 week for your refund to be processed after dropping it off with UPS.
    *Your refund amount is an estimation only.  A refund with the actual amount will be emailed to you after your return has been received.
  </div>
);

ReturnLegalVerbiage.contextTypes = {
  marketplace: PropTypes.object
};

export default ReturnLegalVerbiage;
